import { render, staticRenderFns } from "./home_hotspot.vue?vue&type=template&id=0b8fa3b8&scoped=true"
import script from "./home_hotspot.vue?vue&type=script&lang=js"
export * from "./home_hotspot.vue?vue&type=script&lang=js"
import style0 from "./home_hotspot.vue?vue&type=style&index=0&id=0b8fa3b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fa3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8fa3b8')) {
      api.createRecord('0b8fa3b8', component.options)
    } else {
      api.reload('0b8fa3b8', component.options)
    }
    module.hot.accept("./home_hotspot.vue?vue&type=template&id=0b8fa3b8&scoped=true", function () {
      api.rerender('0b8fa3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_hotspot.vue"
export default component.exports